import { reactive } from 'vue'

// Global state for the airframe health popout (FLY3D-965), so the top-bar button
// can open it while the modal itself is mounted once at app level. Mirrors
// feedbackState, including the minimised flag the dock chip uses.
export const airframeHealthState = reactive({
  isOpen: false,
  minimised: false,

  open() {
    this.minimised = false
    this.isOpen = true
  },

  close() {
    this.isOpen = false
    this.minimised = false
  },

  minimise() {
    this.minimised = true
  },

  restore() {
    this.minimised = false
  },
})
